'use client';

import { TextField } from '@andritzot/metris-web-ui/inputs/textfield';
import { type KeyboardEvent, useEffect, useState } from 'react';

interface HoursCellInputProps {
  value: number;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export function HoursCellInput({ value, onChange, disabled = false }: Readonly<HoursCellInputProps>) {
  const [localValue, setLocalValue] = useState(() => String(value));

  useEffect(() => {
    setLocalValue(String(value));
  }, [value]);

  const stopPropagation = (e: KeyboardEvent) => e.stopPropagation();

  return (
    <TextField
      type="number"
      value={localValue}
      onChange={(e) => setLocalValue(e.target.value)}
      onBlur={() => onChange(String(Math.max(0, Math.round(Number.parseFloat(localValue) || 0))))}
      onKeyDown={stopPropagation}
      size="small"
      disabled={disabled}
      sx={{ width: 80 }}
    />
  );
}
